<template>
  <div ref="wrapper" class="wrapper">
    <v-list expand>
      <v-list-group
        v-for="locationGroupType in locationGroupTypes"
        :key="locationGroupType.type"
        @click="onClick()"
        v-model="locationGroupType.opened"
        :prepend-icon="
          locationGroupType.opened ? 'mdi-menu-up' : 'mdi-menu-down'
        "
        :append-icon="null"
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                <span>{{ locationGroupType.name }}</span>
                <v-chip color="green" text-color="white" class="count-icon"
                  >{{ locationGroupType.groupList.length }}
                </v-chip>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <EmptyGroupList
          v-if="locationGroupType.groupList.length === 0"
          class="group-wrapper"
        />
        <Group
          v-else
          v-for="group in locationGroupType.groupList"
          :group="group"
          :key="group.id"
          class="group-wrapper"
        />
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import Group from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/PointGroup/Group'
import { cx } from 'emotion'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'
import EmptyGroupList from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/PointGroup/EmptyGroupList'

export default {
  name: 'GroupList',
  components: {
    Group,
    EmptyGroupList,
  },
  props: {
    groupList: {
      type: Array,
      default: () => [],
    },
    groupOpen: Boolean,
    ownerProfileId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      locationGroupTypes: [
        {
          type: locationGroupType.CUSTOM_LOCATION,
          name: '地点個別指定',
          groupList: this.groupList.filter(
            group => group.locationType === locationGroupType.CUSTOM_LOCATION,
          ),
          opened: false,
        },
        {
          type: locationGroupType.POI_LOCATION,
          name: '地点カテゴリー',
          groupList: this.groupList.filter(
            group => group.locationType === locationGroupType.POI_LOCATION,
          ),
          opened: false,
        },
      ],
    }
  },
  computed: {
    cx() {
      return cx
    },
  },
  watch: {
    groupOpen() {
      if (!this.groupOpen) {
        const element = this.$refs.wrapper
        element.style.height = 0
      }
      if (this.groupOpen) {
        const element = this.$refs.wrapper
        element.style.height = this.height
      }
    },
  },
  mounted() {
    const element = this.$refs.wrapper
    const { width } = getComputedStyle(element)
    /* eslint-disable no-param-reassign */
    element.style.width = width
    element.style.position = `absolute`
    element.style.visibility = `hidden`
    element.style.height = `auto`
    /* eslint-enable */
    const { height } = getComputedStyle(element)
    /* eslint-disable no-param-reassign */
    element.style.width = null
    element.style.position = null
    element.style.visibility = null
    element.style.height = 0
    /* eslint-enable */
    // Force repaint to make sure the
    // animation is triggered correctly.
    // eslint-disable-next-line no-unused-expressions
    getComputedStyle(element).height
    this.height = height
    this.$nextTick(() => {
      element.style.height = height
    })
  },
  methods: {
    onClick() {
      const element = this.$refs.wrapper
      element.style.height = `auto`
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  margin-left: 30px;
  width: 500px;
  overflow: hidden;
  transition: height 0.3s;
}

.group-wrapper {
  margin-left: 40px;
  width: 500px;
  overflow: hidden;
  transition: height 0.3s;
}

.count-icon {
  height: 17px;
  line-height: 17px;
  margin-left: 10px;
  pointer-events: none;
}

::v-deep .v-list__group__header:hover {
  background-color: inherit !important;
}
::v-deep .v-list__tile {
  height: 40px;
  padding: 0;
}
::v-deep .v-list {
  padding: 0;
}
</style>
